import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { AdvancedMarketsFilterSkeleton } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedEventsLayout/__partials/AdvancedMarketsFilter/Skeleton';
import { AdvancedMatchCardSkeleton } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedMatchCard/Skeleton';
import { MatchCardInlineSkeleton } from 'components/MatchCardInline/Skeleton';
import { NavigationCollapse } from 'components/NavigationCollapse';
import { Skeleton } from 'newcomponents/UI/Skeleton';

const SKELETON_COUNT = 10;

type TAdvancedGamesFilteredByCompetitionsSkeletonProps = {
  showMarketFilterSkeleton?: boolean;
};

export const AdvancedGamesFilteredByCompetitionsSkeleton = ({
  showMarketFilterSkeleton = false
}: TAdvancedGamesFilteredByCompetitionsSkeletonProps) => {
  return (
    <NavigationCollapse
      key={0}
      defaultActive
      wrapperClassName="advancedNavigationCollapseItemWrapper"
      headerClassName="advancedNavigationCollapseItemHeader"
      title={
        <>
          <Skeleton.Avatar
            active
            style={{
              width: 24,
              height: 24
            }}
          />
          <Skeleton.Button
            active
            style={{
              width: 300,
              height: 20
            }}
          />
        </>
      }
    >
      {showMarketFilterSkeleton && <AdvancedMarketsFilterSkeleton />}

      {createArray(SKELETON_COUNT).map(key =>
        isMobile() ? (
          <MatchCardInlineSkeleton key={key} />
        ) : (
          <AdvancedMatchCardSkeleton key={key} />
        )
      )}
    </NavigationCollapse>
  );
};

export const AdvancedGamesFilteredByTimeSkeleton = () => {
  return (
    <NavigationCollapse
      key={0}
      defaultActive
      wrapperClassName="advancedNavigationCollapseItemWrapper"
      headerClassName="advancedNavigationCollapseItemHeader"
      title={
        <Skeleton.Button
          active
          style={{
            width: 300,
            height: 20
          }}
        />
      }
    >
      {createArray(SKELETON_COUNT).map(key =>
        isMobile() ? (
          <MatchCardInlineSkeleton key={key} />
        ) : (
          <AdvancedMatchCardSkeleton key={key} />
        )
      )}
    </NavigationCollapse>
  );
};
